/**
 * Sanitize post-auth redirect paths (web + server).
 * Rejects protocol-relative URLs, external schemes, and auth-loop paths.
 */

export const DEFAULT_RETURN_TO = '/dashboard';

const MAX_RETURN_PATH_LENGTH = 512;

/** Paths that must not be used as post-login redirects. */
const BLOCKED_EXACT_PATHS = new Set([
  '/login',
  '/register',
  '/auth/oauth/callback',
]);

function normalizePathOnly(raw) {
  const withoutQuery = raw.split(/[?#]/)[0] || '';
  const trimmed = withoutQuery.trim();
  if (!trimmed || trimmed.length > MAX_RETURN_PATH_LENGTH) return '';
  return trimmed;
}

function isBlockedReturnPath(path) {
  const lower = path.toLowerCase();
  if (BLOCKED_EXACT_PATHS.has(lower)) return true;
  if (lower.startsWith('/api/auth')) return true;
  return false;
}

/**
 * @param {unknown} input
 * @param {string} [fallback]
 * @returns {string}
 */
export function sanitizeReturnTo(input, fallback = DEFAULT_RETURN_TO) {
  if (typeof input !== 'string') return fallback;
  const trimmed = input.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return fallback;
  if (trimmed.includes('://') || trimmed.includes('\\')) return fallback;
  const pathOnly = normalizePathOnly(trimmed);
  if (!pathOnly.startsWith('/') || pathOnly.startsWith('//')) return fallback;
  if (isBlockedReturnPath(pathOnly)) return fallback;
  return pathOnly;
}
